module.exports = __webpack_public_path__ + "img/ring_coming_soon.7319ae77.jpg";